import ErrorPageShell from '@/components/error-page-shell';
import { buttonVariants } from '@/components/ui/button';
import { Trans, useTranslation } from '@/lib/i18n';
import { useStore } from '@/stores/store';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
import * as z from 'zod';
import { pontoUrl } from './-util';

export const Route = createFileRoute('/__public/novo-cliente/erro')({
  component: RouteComponent,
  validateSearch: z.object({
    messageKey: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.messageKey) {
      return;
    }

    useStore.getState().showAlert({
      type: 'error',
      message: t($ => $.unexpectedError),
    });

    throw redirect({
      to: '/login',
    });
  },
});

function RouteComponent() {
  const { t } = useTranslation(['common', 'public']);

  const search = Route.useSearch();

  const messageKey = search.messageKey as never;

  return (
    <ErrorPageShell
      title={t($ => $.errorPage.title)}
      message={<Trans t={t} i18nKey={messageKey} components={{ br: <br /> }} />}
      button={
        <a href={pontoUrl} className={buttonVariants()}>
          {t($ => $.ok)}
        </a>
      }
    />
  );
}
